import * as React from 'react';
import { Button } from 'antd';

import { FormFieldIds } from 'common/helpers/utils';
import { FilterData } from 'common/helpers/url';
import { PaginationFilters } from 'features/pagination/reducers/paginationReducer';
import { clearFilters } from 'features/pagination/actions/paginationActions';
import { PaginationView } from 'features/pagination/models/paginationModel';
import { RangePicker, ResetButton } from 'common/components/deprecated/form';
import { Antd3Form, StyledAntd3Form, Antd3FormProps } from 'common/components/deprecated/antd3';
import { notificationText, showNotification } from 'common/helpers/notifications';

interface BenefitsDashboardFilterProps {
    formInitial?: PaginationFilters;
    saveFilters(filters: PaginationFilters): void;
    // Matches what ResetButton expects, so the reset can clear this view's saved filters.
    clearFilters: typeof clearFilters;
}

type Props = BenefitsDashboardFilterProps & Antd3FormProps;

/**
 * The Measure dashboards share DashboardFilter, but its project date range
 * (contract_date_range_*) is not a filter the benefits dashboard endpoint accepts. This form
 * filters on the benefit's own completion date instead, which is the date shown in the
 * "Completion Date" column and the one the Overdue and Outstanding tabs are ordered by.
 */
class BenefitsDashboardFilterComponent extends React.Component<Props> {
    private handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // Stops the submit reaching any surrounding page form through the drawer portal.
        event.stopPropagation();

        this.props.form.validateFields((error, values) => {
            if (error) {
                return showNotification({ text: notificationText.Error });
            }

            return this.props.saveFilters({
                paginatedView: PaginationView.BenefitsDashboard,
                values,
            });
        });
    };

    public render(): JSX.Element {
        const { form, formInitial } = this.props;
        const values: FilterData = formInitial ? formInitial.values : {};

        return (
            <StyledAntd3Form onSubmit={this.handleSubmit} header="Filter Benefits">
                <ResetButton
                    form={form}
                    clearFilters={this.props.clearFilters}
                    paginationView={PaginationView.BenefitsDashboard}
                />
                <RangePicker
                    form={form}
                    label="Completion Date"
                    inputs={[
                        {
                            id: FormFieldIds.MinEndDate,
                            placeholder: 'From',
                            initialValue: values.minEndDate,
                        },
                        {
                            id: FormFieldIds.MaxEndDate,
                            placeholder: 'To',
                            initialValue: values.maxEndDate,
                        },
                    ]}
                />
                <Antd3Form.Item>
                    <Button type="primary" htmlType="submit">
                        Filter
                    </Button>
                </Antd3Form.Item>
            </StyledAntd3Form>
        );
    }
}

export const BenefitsDashboardFilter = Antd3Form.create({})(BenefitsDashboardFilterComponent);
